/* eslint-disable react/no-danger */
import { ReCaptchaProvider } from "@wss/re-captcha";
import { z } from "zod";
import ct from "class-types.macro";
import React, { useState } from "react";
import SubmissionResult from "~/Brochure/SubmissionResult/SubmissionResult";
import ValidatedForm from "~/common/Form/ValidatedForm";

import SubscriptionSignUpForm from "./SubscriptionSignUpForm";

const validationSchema = z.object({
  EmailAddress: z
    .string()
    .nonempty("The Email field is required.")
    .email("The Email field is not a valid e-mail address."),
});

interface Props {
  submissionUrl: string;
  header: string;
  description: string;
  image: string;
}

export default function FoodServiceResourcesSubscribe({
  header = "",
  description = "",
  image,
  ...props
}: Props) {
  const [submissionResponse, setSubmissionResponse] = useState<
    SubmissionResult | "GeneralFailure"
  >();
  const [successMessage, setSuccessMessage] = useState<string>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ReCaptchaProvider>
      <div data-module="foodServiceResourcesSubscribe">
        <div className="fsr-email-prompt flex flex-col items-center w-auto lt:w-full">
          <div className="footer-sprite email block inset-0">Email</div>
          <p
            className="header-2 clears subscription-box-header"
            dangerouslySetInnerHTML={{ __html: header }}
          />
          <p
            className="small clears subscription-box-description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <ValidatedForm<SubmissionResult>
            {...props}
            validationSchema={validationSchema}
            beforeSubmit={() => {
              setIsSubmitting(true);
              setSuccessMessage(undefined);
              setSubmissionResponse(undefined);
            }}
            onSubmitSuccess={(response) => {
              setIsSubmitting(false);
              setSuccessMessage(response.message);
            }}
            onSubmitError={(response) => {
              setIsSubmitting(false);
              setSubmissionResponse(response);
            }}
          >
            {successMessage && successMessage.length > 0 ? (
              <div className={ct("text-lg", "mb-4")}>{successMessage}</div>
            ) : (
              <SubscriptionSignUpForm
                {...{ isSubmitting, submissionResponse }}
              />
            )}
          </ValidatedForm>
          {image?.length > 0 && (
            <img
              alt=""
              className="fsr-chef subscription-box-image"
              src={image}
            />
          )}
        </div>
      </div>
    </ReCaptchaProvider>
  );
}
